export default __webpack_public_path__ + "3a6f7e62609a28b376b54c5dcd24b566.webp";